module.exports = __webpack_public_path__ + "static/media/ImgNovedades210805_2.459f1ae0.jpg";